export interface Episode {
  id: string;
  no: number;
  title: string;
  summary: string;
  highlight: string;
}

export const episodes: Episode[] = [
  {
    id: 'ep01',
    no: 1,
    title: '门铃响起的辣妹',
    summary: '放学回家，悠斗打开门，发现全校知名的辣妹黑田美咲正拎着行李箱站在门口。因家中突发状况无处可去的她，提出了一个让人措手不及的请求。',
    highlight: '两人"同居"日常的起点，也是全篇的第一个名场面。',
  },
  {
    id: 'ep02',
    no: 2,
    title: '书架与秘密',
    summary: '美咲惊讶地发现悠斗家里竟有整整一面墙的漫画收藏。两人第一次在漫画的话题上聊得停不下来，也悄悄拉近了距离。',
    highlight: '暴露美咲"漫画迷"真面目的关键回。',
  },
  {
    id: 'ep03',
    no: 3,
    title: '辣妹的作息',
    summary: '住在一起的第一周，生活习惯的巨大差异接连爆发：作息时间、房间整洁度、晚餐口味……吵吵闹闹间，却也逐渐磨合出默契。',
    highlight: '笑料密集的日常回，正式确立"欢喜冤家"组合。',
  },
  {
    id: 'ep04',
    no: 4,
    title: '下雨的傍晚',
    summary: '一场突如其来的大雨，让两人被困在同一个屋檐下。安静的氛围里，美咲难得露出害羞的一面，悠斗也第一次心动。',
    highlight: '感情线开始冒头的转折回。',
  },
  {
    id: 'ep05',
    no: 5,
    title: '来自闺蜜的试探',
    summary: '千夏对好友"寄居男同学家"一事充满好奇，一连串的试探和误会接连上演，让悠斗疲于应付，也让美咲在慌乱中认清自己的心意。',
    highlight: '喜剧密度最高的一集。',
  },
  {
    id: 'ep06',
    no: 6,
    title: '妹妹的观察日记',
    summary: '早就察觉一切的妹妹美琴，用一场"家庭晚餐"轻轻推了两人一把。长辈视角的温柔介入，让这段关系第一次被认真看待。',
    highlight: '亲情与友情的温暖回。',
  },
  {
    id: 'ep07',
    no: 7,
    title: '文化祭的约定',
    summary: '班级文化祭企划让平时就抢眼的辣妹组合大放异彩，而站在幕后默默帮忙的悠斗，终于迎来了被美咲主动拉进聚光灯下的时刻。',
    highlight: '大型集体活动回，感情与友情双双升温。',
  },
  {
    id: 'ep08',
    no: 8,
    title: '暑假的开始',
    summary: '假期前夜，两人第一次认真规划"今后"。关于留与走、关于未来，一段看似平常的对话，却藏着彼此都不敢说破的心事。',
    highlight: '全篇情感浓度的分水岭。',
  },
  {
    id: 'ep09',
    no: 9,
    title: '属于两人的日常',
    summary: '一起吃饭、一起追更、一起熬夜看新刊——那些平淡到不起眼的日常，在不知不觉间，成为两人最想守护的东西。',
    highlight: '甜度满分的日常回。',
  },
  {
    id: 'ep10',
    no: 10,
    title: '吐露心意的深夜',
    summary: '美咲在深夜的客厅里，终于鼓起勇气说出那句藏在心里许久的话。悠斗的回应，让这段从"寄居"开始的关系走向新的阶段。',
    highlight: '表白名场面，剧情主线迎来高潮。',
  },
  {
    id: 'ep11',
    no: 11,
    title: '从"泡在我家"开始',
    summary: '当"借住"的理由慢慢褪去，两人都明白，留在对方身边的早已不是一场巧合。面对未来的选择，他们给出了各自的答案。',
    highlight: '确定心意后的甜度爆发回。',
  },
  {
    id: 'ep12',
    no: 12,
    title: '家门永远为你敞开',
    summary: '故事暂告一段落，回归平凡却温暖的日常。门铃依然会响起，而这一次，迎接美咲的，是真正属于"家"的回应。',
    highlight: '阶段性的暖心收尾，为续章留足想象空间。',
  },
];